import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    display: flex;
    margin-top: 20px;
`;

export const ProfileFlex = styled.div`
    display: flex;
    align-items: center;
    flex: 1;
`;

export const UserDetailsFlex = styled.div`
    display: flex;
    justify-content: center;
    flex: 4;
    flex-direction: column;
    margin-left: 10px;
`;

export const Name = styled.div`
    display: flex;
    font-weight: 600;
    font-size: 22px;
    line-height: 32px;
    color: #040222;
`;

export const Phone = styled.div`
    display: flex;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #5b5675;
    margin-top: 6px;
`;
